import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Button } from 'antd'
import store from '../../store/configureStore'

class BookingButton extends Component {
  onRequestService() {
    const { history, fromgarage } = this.props
    const userState = store.getState().user
    let user = userState.data ? userState.data : {}
    const isLoggedIn = user.email ? true : false
    if (fromgarage) {
      history.push('/booking')
    } else if (isLoggedIn) {
      history.push('/my-garage')
    } else {
      history.push('/booking')
    }
  }

  render() {
    const { buttontext } = this.props
    let cleanedupProps = Object.assign({}, this.props)
    delete cleanedupProps.staticContext //to avoid warnings in console
    let textToBeShown = buttontext ? buttontext : 'Request Service'
    return (
      <Button {...cleanedupProps} onClick={() => this.onRequestService()}>
        {textToBeShown}
      </Button>
    )
  }
}
export default withRouter(BookingButton)



// WEBPACK FOOTER //
// ./src/components/booking/BookingButton.js